import { AlertTriangle } from "lucide-react";

/**
 * Small inline status badge for Alvys-sourced trucks/trailers/drivers.
 * - `Active` → renders nothing (default state; keeps the UI clean).
 * - `Inactive` → gray.
 * - `Leased Out` → amber.
 * - `Repair` → red.
 * - `Crashed` → red with warning icon.
 * - any unknown non-Active status → gray with the raw text (safe default).
 */
export default function TmsStatusBadge({ status, testId }) {
  if (!status) return null;
  const s = String(status).trim();
  if (!s) return null;
  // Default/operational states that don't deserve a badge:
  //   - trailers/trucks: "Active"
  //   - drivers:         "ONLINE", "OFF DUTY" (both are normal operating states)
  const u = s.toUpperCase();
  if (u === "ACTIVE" || u === "ONLINE" || u === "OFF DUTY") return null;

  let cls = "bg-slate-200 text-slate-700";
  let icon = null;
  if (s === "Leased Out") cls = "bg-amber-100 text-amber-800";
  else if (s === "Repair") cls = "bg-red-100 text-red-800";
  else if (s === "Crashed") { cls = "bg-red-100 text-red-800"; icon = <AlertTriangle className="h-3 w-3" />; }
  else if (s === "Inactive" || u === "OFFLINE") cls = "bg-slate-200 text-slate-700";

  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1 rounded-full px-1.5 py-0.5 text-[10px] font-medium leading-none ${cls}`}
    >
      {icon}
      {s}
    </span>
  );
}
